import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const SouthKoreaPage = () => {
  return <DestinationTemplate destinationId="southkorea" />;
};

export default SouthKoreaPage;
